const getTimeZoneOffset = () => {
  const f = (num, plus = '') => `${num < 0 ? '-' : plus}${Math.abs(num) < 9 ? '0' : ''}${Math.abs(num)}`;
  const offset = -(new Date().getTimezoneOffset());
  const hh = Math.floor(offset / 60);
  const mm = Math.abs(offset - (hh * 60));
  return `${f(hh, '+')}:${f(mm)}`;
};

export default getTimeZoneOffset;
